import React from 'react'

export const SuccessIcon = (
  color = '#12C75D',
  secondaryColor = '#E1FEE6',
  width = 70,
  height = 50
) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 70 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.875" cy="16.875" r="1.875" fill={color} />
      <circle cx="65.625" cy="38.125" r="1.875" fill={color} />
      <circle cx="8.125" cy="11.875" r="0.625" fill={color} />
      <circle cx="6.25" cy="28.75" r="1.25" fill={color} />
      <circle cx="63.125" cy="45.625" r="0.625" fill={color} />
      <circle cx="68.75" cy="28.75" r="1.25" fill={color} />
      <rect x="11.25" width={50} height={50} rx={25} fill={secondaryColor} />
      <path
        d="M34.15 31.9L44.725 21.325L42.625 19.225L34.15 27.7L29.875 23.425L27.775 25.525L34.15 31.9ZM36.25 40C34.175 40 32.225 39.6062 30.4 38.8187C28.575 38.0312 26.9875 36.9625 25.6375 35.6125C24.2875 34.2625 23.2188 32.675 22.4313 30.85C21.6437 29.025 21.25 27.075 21.25 25C21.25 22.925 21.6437 20.975 22.4313 19.15C23.2188 17.325 24.2875 15.7375 25.6375 14.3875C26.9875 13.0375 28.575 11.9688 30.4 11.1813C32.225 10.3937 34.175 10 36.25 10C38.325 10 40.275 10.3937 42.1 11.1813C43.925 11.9688 45.5125 13.0375 46.8625 14.3875C48.2125 15.7375 49.2812 17.325 50.0687 19.15C50.8562 20.975 51.25 22.925 51.25 25C51.25 27.075 50.8562 29.025 50.0687 30.85C49.2812 32.675 48.2125 34.2625 46.8625 35.6125C45.5125 36.9625 43.925 38.0312 42.1 38.8187C40.275 39.6062 38.325 40 36.25 40Z"
        fill={color}
      />
    </svg>
  )
}
